"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _list = _interopRequireDefault(require("webmotors-react-pj/frame/menu/list"));
var _utils = require("webmotors-react-pj/utils");
var _icon = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/icon"));
var _img = _interopRequireDefault(require("webmotors-react-pj/img"));
var _menu = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/menu"));
var _v = _interopRequireDefault(require("webmotors-react-pj/tag-analytics/v2"));
var _style = _interopRequireWildcard(require("webmotors-react-pj/frame/menu/user-options/style"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = _ref => {
  let {
    opened,
    setOpened
  } = _ref;
  const {
    nameid
  } = (0, _utils.jwtGet)();
  const [openUserDetails, setOpenUserDetails] = (0, _react.useState)(false);
  const handleSeeDetails = () => {
    setOpenUserDetails(!openUserDetails);
    !openUserDetails && (0, _v.default)('pj_cockpit_menuVerDetalhes', {
      site: {
        subEnvironment: 'homepage'
      },
      page: {
        flowType: 'cockpit',
        pageType: 'cockpit-homepage',
        pageName: '/webmotors/cockpit/homepage',
        'pageName.tier1': 'cockpit',
        'pageName.tier2': 'homepage',
        'pageName.tier3': undefined,
        loadTime: window.performance.PerformanceNavigationTiming
      }
    });
  };
  return _react.default.createElement(_style.default, null, _react.default.createElement(_style.StyleUserInfo, {
    onClick: () => handleSeeDetails(),
    "data-qa": "menuSeeUserDetailsHeader"
  }, _react.default.createElement(_style.StyleAvatarWrapper, null, _react.default.createElement(_icon.default, {
    open: true,
    size: 24
  }, nameid && nameid[0] || "🛱"), _react.default.createElement(_style.StyleUserDetails, null, _react.default.createElement(_style.StyleUserName, null, nameid))), _react.default.createElement(_style.StyleArrow, {
    openned: openUserDetails
  })), openUserDetails && _react.default.createElement(_style.StyleUserDetailsMenu, null, _react.default.createElement(_style.StyleUserDetailsCollapse, {
    "data-qa": "menuUserDetailsWrapper",
    opened: openUserDetails
  }, _react.default.createElement(_menu.default, null))));
};
exports.default = _default;